export default "__VITE_ASSET__D_UJg$Gx__"